<template>
  <div class="form-section">
    <div v-for="(step, index) in steps" :key="step.id" class="step-container">
      <!-- Step Indicator -->
      <div class="step-indicator-container">
        <div class="step-item">
          <div>
            <div
              :class="[
                'step-circle',
                {
                  completed:
                    (step.id === 1 && companyInfoCompleted) ||
                    (step.id === 2 && chooseUnitCompleted) ||
                    (step.id === 3 && effectiveDateCompleted),
                  active: step.id === currentStep,
                  disabled: disabledNotDraft,
                },
              ]"
            >
              <img src="~@/assets/icon/check-white.svg" alt="" />
            </div>
          </div>
          <div v-if="index < steps.length - 1" class="step-line" />
        </div>
      </div>
      <div class="step-content-container">
        <!-- Step Content -->
        <div class="step-content">
          <choose-target-company :isActive="true" v-if="step.id === 1" />
          <choose-unit
            :isActive="companyInfoCompleted || isAnySelectedUnit"
            v-if="step.id === 2"
          />
          <effective-date
            :isActive="
              (companyInfoCompleted && chooseUnitCompleted) ||
              isAnyEffectiveDateValue
            "
            v-if="step.id === 3"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Wrapper, LoadingScreen } from "@/components/Layout";
import ChooseTargetCompany from "./DetailFormStep/ChooseTargetCompany/ChooseTargetCompany.vue";
import ChooseUnit from "./DetailFormStep/ChooseUnit/ChooseUnit.vue";
import EffectiveDate from "./DetailFormStep/EffectiveDate/EffectiveDate.vue";

import mixin from "@/components/RentAdjustment/mixin.js";

import { mapGetters } from "vuex";

export default {
  name: "TransferDetail",
  components: {
    Wrapper,
    ChooseTargetCompany,
    ChooseUnit,
    EffectiveDate,
    LoadingScreen,
  },
  mixins: [mixin],
  data() {
    return {
      steps: [
        { id: 1, title: "Pilih Target Perusahaan" },
        { id: 2, title: "Pilih Unit" },
        { id: 3, title: "Tanggal Efektif" },
      ],
    };
  },
  computed: {
    ...mapGetters("rentAdjustment", {
      currentStep: "getCurrentStep",
      getFormData: "getFormData",
      transferUnitStatus: "getStatus",
      disabledNotDraft: "getDisabledNotDraft",
    }),
    isAnySelectedUnit() {
      return this.getFormData.units.some((unit) => unit.selected);
    },
    isAnyEffectiveDateValue() {
      return Boolean(this.getFormData.effectiveDate);
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.btn {
  font-size: 14px;
  padding: 10px 20px;
  border-radius: 8px;
}

.content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 32px 72px;
  overflow-y: auto;
}

.form-section {
  background-color: #ffffff;
  border: 1px solid #d1d9e2;
  border-radius: 0 0 8px 8px;
  padding: 20px;
}

.step-container {
  display: flex;
  gap: 24px;
}

.step-indicator {
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  min-width: 60px;
}

.step-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  height: 100%;
}

.step-circle {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid #d1d9e2;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.step-circle.active {
  border-color: #247fec;
  background-color: #ffffff;
}

.step-circle.completed {
  border-color: #247fec;
  background-color: #247fec;
}

.step-circle.disabled {
  border-color: #565f77;
  background-color: #565f77;
}

.step-line {
  width: 2px;
  min-height: 30px;
  height: 100%;
  background-color: #d1d9e2;
}

.step-content {
  flex: 1;
  width: 100%;
}

.step-content-container {
  flex: 1;
}

/* Responsive */
@media (max-width: 768px) {
  .content {
    padding: 20px;
  }

  .step-container {
    flex-direction: column;
  }

  .step-indicator {
    flex-direction: row;
    min-width: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RentAdjustment/FormTabs/Detail/Detail.vue